export interface PrintEnvelopeParams {
  name: string
  address: string
  phone: string
  date: string
}

const formatTime = (time: string): string => {
  const [hours, minutes] = time.split(':')

  if (hours === undefined || minutes === undefined) {
    return time
  }

  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`
}

export function formatDeliveryDate(
  startDelivery?: string,
  endDelivery?: string,
): string {
  if (!startDelivery) return ''

  const [date, startTime] = startDelivery.split(' ')

  if (!date || !startTime) return startDelivery

  const [year, month, day] = date.split('-')
  const formattedDate = `${day}/${month}/${year}`

  const formattedStartTime = formatTime(startTime)
  const formattedEndTime = formatTime(endDelivery || '')

  return `${formattedDate} с ${formattedStartTime} до ${formattedEndTime}`
}

export function printEnvelope(data: PrintEnvelopeParams) {
  const iframe = document.createElement('iframe')

  Object.assign(iframe.style, {
    position: 'fixed',
    right: '0',
    bottom: '0',
    width: '0',
    height: '0',
    border: '0',
    visibility: 'hidden',
  })

  document.body.appendChild(iframe)

  const win = iframe.contentWindow
  const doc = iframe.contentDocument

  if (!win || !doc) {
    iframe.remove()
    return
  }

  doc.open()

  const html = doc.createElement('html')
  html.lang = 'ru'

  const head = doc.createElement('head')

  const meta = doc.createElement('meta')
  // meta.charset = 'UTF-8'

  const title = doc.createElement('title')
  title.textContent = 'Печать Конверта'

  const style = doc.createElement('style')
  style.textContent = `
    @page {
      size: A4 portrait;
      margin: 0;
    }

    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    html,
    body {
      margin: 0 !important;
      padding: 0 !important;
      background: #ffffff !important;
      color: #000000 !important;
      width: 210mm !important;
      height: auto !important;
    }

    .page-sheet {
      width: 210mm !important;
      height: 297mm !important;
      margin: 0 !important;
      padding: 0 !important;
      box-shadow: none !important;
      page-break-after: always;
      break-after: page;
      position: relative !important;
      overflow: hidden !important;
    }

    .recipient-block {
      position: absolute;
      top: 96.6mm;
      left: 75.2mm;
      width: 134.4mm;
      text-align: center;
      font-family: 'Times New Roman', Times, serif;
      line-height: 1.35;
      transform: rotate(-90deg);
    }

    .envelope-name {
      font-size: 14pt;
      font-weight: bold;
      margin-bottom: 12px;
      color: #000;
      word-wrap: break-word;
    }

    .envelope-address {
      font-size: 14pt;
      font-weight: bold;
      margin-bottom: 2px;
      color: #000;
      word-wrap: break-word;
    }

    .envelope-phone {
      font-size: 18pt;
      font-weight: bold;
      margin-bottom: 2px;
      color: #000;
      word-wrap: break-word;
    }

    .envelope-date {
      font-size: 16pt;
      font-weight: bold;
      margin-bottom: 0;
      color: #000;
      word-wrap: break-word;
    }
  `

  head.append(meta, title, style)

  const body = doc.createElement('body')

  const pageSheet = doc.createElement('div')
  pageSheet.className = 'page-sheet'

  const recipientBlock = doc.createElement('div')
  recipientBlock.className = 'recipient-block'

  const name = doc.createElement('div')
  name.className = 'envelope-name'
  name.textContent = data.name

  const address = doc.createElement('div')
  address.className = 'envelope-address'
  address.textContent = data.address

  const phone = doc.createElement('div')
  phone.className = 'envelope-phone'
  phone.textContent = data.phone

  const date = doc.createElement('div')
  date.className = 'envelope-date'
  date.textContent = data.date

  recipientBlock.append(name, address, phone, date)
  pageSheet.appendChild(recipientBlock)
  body.appendChild(pageSheet)

  html.append(head, body)
  doc.appendChild(html)
  doc.close()

  setTimeout(() => {
    win.focus()
    win.print()

    setTimeout(() => {
      iframe.remove()
    }, 1000)
  }, 250)
}
